// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-header-logo{margin-right:5px}@media (max-width: 424px){.page-header-logo{margin-right:0px}}.page-header-logo .page-header-logo-image{width:160px;height:20.8px}@media (max-width: 424px){.page-header-logo .page-header-logo-image{width:140px;height:18.2px}}@media (min-width: 970px){.page-header-logo{margin-bottom:0px}.page-header-logo .page-header-logo-image{width:180px;height:23.39px}}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
